import { useMemo } from 'react';

import { jobDefinition } from 'utils/jobDefinition';

import { ReportRequestState } from '../model/types';
import { buildReportParams } from '../params/buildParams';
import { jobDefinitionChoices } from '../params/instanceSize';
import { validateReportParams } from '../schema/validateParams';

interface Viewer {
  email: string;
  name: string | null;
}

/** The exact params that would be submitted, and their JSON-schema validation result. */
const useReportParams = (
  state: ReportRequestState,
  viewer: Viewer | null | undefined,
  environment: SensoryLinkEnvironment | null,
  reportUid: string,
) => {
  const params = useMemo(
    () =>
      buildReportParams(state, {
        requestedBy: viewer?.name || viewer?.email || '',
        jobDefinition: jobDefinition(environment),
        jobDefinitionChoices: jobDefinitionChoices(environment),
        generateId: () => reportUid,
      }),
    [state, viewer, environment, reportUid],
  );
  const schema = useMemo(
    () =>
      params && state.reportKind
        ? validateReportParams(state.reportKind, params)
        : null,
    [params, state.reportKind],
  );
  return { params, valid: !!schema?.valid, issues: schema?.issues ?? [] };
};

export default useReportParams;
